import { ControlCodes } from '@bcube/shared/constants';
import { Activity, List, Radio, RefreshCcw, Sheet, Wifi } from 'lucide-react';
import type { ModuleConfig } from './types';

export const connectivityModule: ModuleConfig = {
  id: 'connectivity',
  title: 'Módulo Conectividade',
  description: 'Gestão de dispositivos e ativação de conectividade LoRa.',
  basePath: '/connectivity',
  icon: Wifi,
  navigation: [
    {
      name: 'Sincronização KORA',
      pathname: '/connectivity/kora-sync',
      icon: <RefreshCcw size={16} className="text-muted-foreground" />,
      code: ControlCodes.connectivity_kora_sync,
    },
    {
      name: 'Ativação LoRaWan',
      pathname: '/connectivity/lora-activation',
      icon: <Activity size={16} className="text-muted-foreground" />,
      code: ControlCodes.connectivity_lora_activation,
      children: [
        {
          name: 'Logs de ativação',
          pathname: '/connectivity/lora-activation-logs',
          icon: <List size={16} className="text-muted-foreground" />,
          code: ControlCodes.connectivity_lora_activation,
        },
        {
          name: 'Ações em massa',
          pathname: '/connectivity/batch-lora-activation',
          icon: <Sheet size={16} className="text-muted-foreground" />,
          code: ControlCodes.connectivity_lora_activation,
        },
      ],
    },
  ],
  landingActions: [
    {
      title: 'Sincronização KORA',
      href: '/connectivity/kora-sync',
      code: ControlCodes.connectivity_kora_sync,
      icon: RefreshCcw,
      iconForeground: 'text-blue-700',
      iconBackground: 'bg-blue-50',
      description: 'Sincronize dispositivos KORA com o sistema BCube.',
    },
    {
      title: 'Ativação LoRa',
      href: '/connectivity/lora-activation',
      code: ControlCodes.connectivity_lora_activation,
      icon: Radio,
      iconForeground: 'text-emerald-700',
      iconBackground: 'bg-emerald-50',
      description: 'Ative dispositivos LoRa, gerencie credenciais e monitore status de conexão.',
    },
  ],
};
